<template>
  <div id="app">
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  mounted() {
    // 初始化判断
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("mobile") > -1) {
      console.log("pc");
    }
  },
  methods: {},
};
</script>

<style lang="stylus">
@import '~@/style/public.styl'
@import '~@/style/scroller.styl'
@import '~@/style/search.styl'
@import '~@/style/form.styl'
@import '~@/style/common.styl'
@import '~@/style/element.styl'
@import '~@/style/transition.styl'
</style>
